import { useEffect, useState } from 'react';
import { RootState } from '../../../../Redux/Store';
import { useAppSelector } from '../../../../Hooks/Hooks';
import { fbLogEvent } from '../../../../Helpers/FirebaseHelper';
import { EVENT, SCREEN, TAB } from '../../../../Constants/AnalyticsConstants';
import { commonDateFormat } from '../../../../Utils/DateUtils';
import { deadHeadValidation } from '../../../../Utils/Search';
import { getLoadStopCommodities } from '../../../../Utils/LoadStopCommoditiesUtil';
import LoadCommoditiesContainer from './LoadCommoditiesContainer/LoadCommoditiesContainer';
import LoadMapContainer from './LoadMapContainer/LoadMapContainer';
import LoadRateContainer from './LoadRateContainer/LoadRateContainer';
import LoadServicesContainer from './LoadServicesContainer/LoadServicesContainer';
import LoadDocumentsContainer from './LoadDocumentsContainer/LoadDocumentsContainer';
import LoadReferencesContainer from './LoadReferencesContainer/LoadReferencesContainer';
import { ExpandedViewNavigation, TExpandedViewContainerProps } from './ExpandedViewContainer.type';
import './ExpandedViewContainer.scss';

export const specialServicesDesc = (data: any) => {
  let specialServices: any[] = [];
  data?.specialServices?.forEach((item: any) => {
    specialServices.push(item?.specialServiceDesc);
  });
  return specialServices;
};

const ExpandedViewContainer = (props: TExpandedViewContainerProps) => {
  const { data, isRecent, isNewSearch, isFavorite, isWatchedLoads, isMyLoads } = props;
  const { loadDetails } = useAppSelector((state: RootState) => state.myLoads);
  const { configTableData } = useAppSelector((state: RootState) => state.ContentOrConfig);
  const appConfigData = configTableData?.FPO_APP_CONFIG;
  const [expandedNav, setexpandedNav] = useState<any[]>([]);

  useEffect(() => {
    setexpandedNav(
      ExpandedViewNavigation?.map((item: any) => {
        return { ...item, selected: item?.seq === 1 };
      }),
    );
  }, []);

  const handleNavChange = (nav: any) => {
    setexpandedNav(
      ExpandedViewNavigation?.map((item: any) => {
        return { ...item, selected: item?.slug === nav };
      }),
    );
  };
  const sortedStops = (loadStop: any): any[] => {
    const temp = [...loadStop];
    return temp.sort(
      (a: any, b: any) => (a.stopSequence || a.sequenceNo) - (b.stopSequence || b.sequenceNo),
    );
  };

  const filteredTabs = (expandedNav: any) => {
    const myLoadsCommodity =
      (isMyLoads && getLoadStopCommodities(loadDetails[0]?.shipmentStops)) || [];
    if (data?.loadCommodityList?.length === 0) {
      expandedNav = expandedNav.filter((item: any) => item.slug !== 'commodities');
    }
    if (!data?.specialServices?.length || data?.specialServices === null) {
      expandedNav = expandedNav.filter((item: any) => item.slug !== 'services');
    }
    if (data?.rate === null) {
      expandedNav = expandedNav.filter((item: any) => item.slug !== 'rate');
    }
    if (data?.loadStop?.length === 0 || data?.shipmentStops?.length === 0) {
      expandedNav = expandedNav.filter((item: any) => item.slug !== 'map');
    }
    if (!data?.shipmentAndStopReferences?.length) {
      expandedNav = expandedNav.filter((item: any) => item.slug !== 'references');
    }
    if (!isMyLoads) {
      expandedNav = expandedNav.filter((item: any) => item.slug !== 'documents');
    }
    return expandedNav;
  };

  const tabs = filteredTabs(expandedNav);

  useEffect(() => {
    const selectedNav = tabs?.find((item: any) => item?.selected)?.slug;
    var lead;
    if (isNewSearch) {
      lead = TAB.NEW;
    } else if (isRecent) {
      lead = TAB.RECENT;
    } else if (isFavorite) {
      lead = TAB.FAVORITE;
    } else if (isWatchedLoads) {
      lead = TAB.WATCHED;
    }
    switch (selectedNav) {
      case 'map':
        fbLogEvent(EVENT.SV_VIEW_LOAD_MAP, {
          screen: SCREEN.LOAD_DETAILS,
          tab: selectedNav,
          loadId: data?.loadId,
          lead: lead,
          ...(data?.division && { load_divison: data?.division }),
          ...(data?.rate?.binSources && { load_source_tms: data?.rate?.binSource }),
          ...(data?.rate?.binRateIdentifier && {
            load_bin_rate_id: data?.rate?.binRateIdentifier,
          }),
          ...(data?.estimatedTotalRpm && { load_estimated_rpm: data?.estimatedTotalRpm }),
        });
        break;

      case 'commodities':
        fbLogEvent(EVENT.SV_VIEW_LOAD_COMMODITIES, {
          screen: SCREEN.LOAD_DETAILS,
          tab: selectedNav,
          loadId: data?.loadId,
          lead: lead,
          ...(data?.division && { load_divison: data?.division }),
          ...(data?.rate?.binSources && { load_source_tms: data?.rate?.binSource }),
          ...(data?.rate?.binRateIdentifier && {
            load_bin_rate_id: data?.rate?.binRateIdentifier,
          }),
          ...(data?.estimatedTotalRpm && { load_estimated_rpm: data?.estimatedTotalRpm }),
        });
        break;
      case 'commodities_additional':
        fbLogEvent(EVENT.SV_VIEW_LOAD_COMMODITIES_ADDITIONAL, {
          screen: SCREEN.LOAD_DETAILS,
          tab: selectedNav,
          loadId: data?.loadId,
          lead: lead,
          ...(data?.division && { load_divison: data?.division }),
          ...(data?.rate?.binSources && { load_source_tms: data?.rate?.binSource }),
          ...(data?.rate?.binRateIdentifier && {
            load_bin_rate_id: data?.rate?.binRateIdentifier,
          }),
          ...(data?.estimatedTotalRpm && { load_estimated_rpm: data?.estimatedTotalRpm }),
        });
        break;
      case 'rate':
        fbLogEvent(EVENT.SV_VIEW_LOAD_RATE, {
          screen: SCREEN.LOAD_DETAILS,
          tab: selectedNav,
          loadId: data?.loadId,
          lead: lead,
          ...(data?.division && { load_divison: data?.division }),
          ...(data?.rate?.binSources && { load_source_tms: data?.rate?.binSource }),
          ...(data?.rate?.binRateIdentifier && {
            load_bin_rate_id: data?.rate?.binRateIdentifier,
          }),
          ...(data?.estimatedTotalRpm && { load_estimated_rpm: data?.estimatedTotalRpm }),
        });
        break;
      case 'services':
        fbLogEvent(EVENT.SV_VIEW_LOAD_SERVICES, {
          screen: SCREEN.LOAD_DETAILS,
          tab: selectedNav,
          loadId: data?.loadId,
          lead: lead,
          ...(data?.division && { load_divison: data?.division }),
          ...(data?.rate?.binSources && { load_source_tms: data?.rate?.binSource }),
          ...(data?.rate?.binRateIdentifier && {
            load_bin_rate_id: data?.rate?.binRateIdentifier,
          }),
          ...(data?.estimatedTotalRpm && { load_estimated_rpm: data?.estimatedTotalRpm }),
        });
        break;
    }
  }, [expandedNav]);

  const renderNavBasedComponent = (data: any) => {
    const selectedNav = tabs?.find((item: any) => item?.selected)?.slug;
    switch (selectedNav) {
      case 'map':
        return (
          <div className="Map_Section">
            <LoadMapContainer data={data} showExpandedView={true} />
          </div>
        );
      case 'commodities':
        return (
          <LoadCommoditiesContainer
            commodities={
              data?.loadCommodityList || getLoadStopCommodities(loadDetails[0]?.shipmentStops)
            }
          />
        );
      case 'rate':
        return (
          <LoadRateContainer
            tableTitle={'Rate Details'}
            rate={data?.rate || data?.shipmentCostItems}
            totalCostAmount={data?.totalCostAmount}
            isMyLoads={isMyLoads}
          />
        );
      case 'services':
        return (
          <LoadServicesContainer
            services={specialServicesDesc(data)}
            tableTitle={'Services Details'}
          />
        );
      case 'references':
        return (
          <LoadReferencesContainer
            references={data?.shipmentAndStopReferences || data?.shipmentReferences}
          />
        );
      case 'documents':
        return (
          <LoadDocumentsContainer
            id={data?.shipmentId}
            sourceTms={data?.sourceTMS}
            modalView={false}
            isMyLoads={isMyLoads}
          />
        );
      default:
        return <div>Work in progress</div>;
    }
  };

  const loadStop = data?.loadStop || data?.shipmentStops;
  return (
    <div data-testid="expanded-view-container" className="ExpandedViewContainer">
      <div className="Expanded_View_Navigation">
        {tabs?.map((item: any) => {
          return (
            <div
              className={`Expanded_View_Nav_item ${item?.selected ? 'Selected' : ''}`}
              key={item?.seq}
              onClick={() => handleNavChange(item?.slug)}
            >
              {item?.label}
            </div>
          );
        })}
      </div>
      <div className="Expanded_View_Content">
        <div className="Expanded_View_Left">{renderNavBasedComponent(data)}</div>
        <div className="Expanded_View_Right">
          {loadStop.length &&
            sortedStops(loadStop)?.map((item: any) => {
              return (
                <div key={item?.stopId} className="Expanded_View_Right_Stop">
                  <div className="Stop_indicator">
                    <img
                      src={`/oo/assets/icon/${
                        item?.stopSequence == 1 || item?.sequenceNo == 1
                          ? 'origin_icon'
                          : item?.stopSequence == loadStop?.length ||
                              item?.sequenceNo == loadStop?.length
                            ? 'destination_icon'
                            : 'stop-pointer'
                      }.svg`}
                      alt="Stop_indicator_icon"
                    />
                  </div>
                  <div className="Location_Details">
                    <div className="Location_City_State">
                      {item?.city},{item?.state && ` ${item?.state}`}
                    </div>
                    {item?.locationName && (
                      <div className="Location_locationName">{item?.locationName}</div>
                    )}
                    {item?.addressLine1 && (
                      <div className="Location_addressLine1">{item?.addressLine1}</div>
                    )}
                    {item?.addressLine2 && (
                      <div className="Location_addressLine2">{item?.addressLine2}</div>
                    )}
                    {item?.city && item?.state && (
                      <div className="Location_City_State_Pin">
                        {item?.city},{item?.state && ` ${item?.state}`}
                        {item?.postalCode && ` ${item?.postalCode}`}
                      </div>
                    )}
                    {isMyLoads && (
                      <div className="StopActuals">
                        <div className="StopActualsTitle">Arrived :</div>
                        <div className="StopActualsValue">
                          {commonDateFormat(
                            item?.actualArrivalDateTime,
                            false,
                            true,
                            item?.timeZone ? item?.timeZone : null,
                          )}
                        </div>
                        <div className="StopActualsTitle">Departed :</div>
                        <div className="StopActualsValue">
                          {commonDateFormat(
                            item?.actualDepartureDateTime,
                            false,
                            true,
                            item?.timeZone ? item?.timeZone : null,
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="Appointment_Details">
                    {((item?.appointmentTo && item?.appointmentFrom) ||
                      (item?.plannedDepartureDateTime && item?.plannedArrivalDateTime)) && (
                      <div className="Appointment_Time">
                        {commonDateFormat(
                          item?.appointmentFrom || item?.plannedArrivalDateTime,
                          false,
                          true,
                          item?.timeZone ? item?.timeZone : null,
                        )}
                        {' - '}
                        <br />
                        {commonDateFormat(
                          item?.appointmentTo || item?.plannedDepartureDateTime,
                          false,
                          true,
                          item?.timeZone ? item?.timeZone : null,
                        )}{' '}
                      </div>
                    )}
                    {isMyLoads && (
                      <div className="Stop_Actions">
                        {item?.stopActivity?.map((item: any, index: number) => (
                          <span key={item?.tmsActivity + index}>
                            <span
                              style={
                                appConfigData?.SPECIAL_STOP_ACTIONS_INIT?.[item?.tmsActivity] ||
                                null
                              }
                            >
                              {item?.tmsActivity}
                              <br />
                            </span>
                          </span>
                        ))}
                      </div>
                    )}
                    {isMyLoads && (
                      <div className="Trailer">
                        <div className="TrailerTitle">Trailer In :</div>
                        <div className="TrailerValue">
                          {item?.stopActivity?.map(
                            (item: any, index: number) =>
                              item.execActivity === 'TRAILER_IN' && (
                                <span key={item?.equipmentId + index}>{item?.equipmentId}</span>
                              ),
                          )}
                        </div>
                        <div className="TrailerTitle">Trailer Out :</div>
                        <div className="TrailerValue">
                          {item?.stopActivity?.map(
                            (item: any, index: number) =>
                              item.execActivity === 'TRAILER_OUT' && (
                                <span key={item?.equipmentId + index}>{item?.equipmentId}</span>
                              ),
                          )}
                        </div>
                      </div>
                    )}
                    {!isMyLoads && item?.specialServices?.length > 0 && (
                      <div className="Appointment_specialServices">
                        {item?.specialServices?.map((item: any, index: number) => (
                          <span key={item?.specialServiceDesc}>
                            <span
                              style={
                                appConfigData?.SPECIAL_STOP_ACTIONS_INIT?.[
                                  item?.specialServiceDesc
                                ] || null
                              }
                            >
                              {item?.specialServiceDesc}
                              <br />
                            </span>
                          </span>
                        ))}
                      </div>
                    )}
                    {deadHeadValidation(item?.deadHead) && (
                      <div className="Appointment_deadHead">Empty {item?.deadHead} mi</div>
                    )}
                    {!isMyLoads && item?.stopSequence && (
                      <div className="Appointment_stopSequence">
                        Stop {item?.stopSequence}:{' '}
                        {item?.stopType === 'P'
                          ? 'Pickup'
                          : item?.stopType === 'D'
                            ? 'Drop'
                            : 'NFR'}
                      </div>
                    )}
                    {item?.timeZone && <div>Time Zone: {item?.timeZone}</div>}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default ExpandedViewContainer;
